import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { Level } from 'src/app/_models/level';

import { EducationService } from 'src/app/_services/education.service';

@Component({
  selector: 'app-modal-add-level',
  templateUrl: './modal-add-level.component.html',
  styleUrls: ['./modal-add-level.component.css']
})
export class ModalAddLevelComponent implements OnInit {
  @Input() country =undefined

  myForm;
  educationSystems=[]

  @Output() addLevelSaveEvent = new EventEmitter<string>()
  @Output() levelIndexCloseModalEvent = new EventEmitter<string>()

  constructor(private educationService:EducationService){}

  get f() {
    return this.myForm.controls
  }

  ngOnInit(): void {

    this.initMainFormFresh()
    this.educationService.getEducationSystems().subscribe(
      data=>{this.educationSystems=data}
    )

  }
  form_submit() {
    let level=new Level()
    level.name = this.f.name.value
    level.shortName = this.f.shortName.value
    level.description = level.name + " " +this.country['name']
    level.server_country_id = this.country['id']
    level.ordinalNumber = this.f.ordinalNumber.value
    this.addLevelSaveEvent.emit(level.formData())
    this.closeModal()
  }
  closeModal(){
     this.levelIndexCloseModalEvent.emit("close")
  }

  initMainFormFresh(){
    this.myForm=new FormGroup({
      name: new FormControl('', Validators.compose([Validators.required,Validators.minLength(3)])),
      shortName: new FormControl("",Validators.compose([Validators.required,Validators.minLength(3)])),
      description: new FormControl(""),
      ordinalNumber:new FormControl('',Validators.required),
      country:new FormControl('',Validators.required)
    });
  }
}



